(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("badgeCriteria", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/public/badgeCriteriaView.html",
            controller: ["publicOpenBadgesResource", "messageService", "$rootScope", "$stateParams", "$window", BadgeCriteriaCtrl],
            controllerAs: "vm"
        };
        function BadgeCriteriaCtrl(publicOpenBadgesResource, messageService, $rootScope, $stateParams, $window) {
            var vm = this;
            vm.loading = true;
            $rootScope.showPageLoader = false;
            publicOpenBadgesResource.getBadgeCriteria({ badgeGuid: $stateParams.badgeGuid, localizationId: $stateParams.localizationId }, function (data) {
                vm.badgeDetails = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.loadIssuer = function () {
                $window.open(vm.badgeDetails.issuer.url);
            };
        }
    });
}());
